import React from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const DeleteInteractionModal = observer(() => {
    const {modalStore, generalStore} = useStores();
    const {interactionName, interactionId} = modalStore.modalData;

    function downHandler({key}) {
        if (key === 'Enter') {
            modalStore.modalData.deleteMethod(interactionId).then();
            closeModal();
        }
    }

    function closeModal() {
        window.removeEventListener('keydown', downHandler)
        modalStore.isDeleteInteractionDialogOpen = false;
        modalStore.modalData = {procedure: modalStore.modalData.procedure};
    }

    return (
        <GeneralDialog
            openControl='isDeleteInteractionDialogOpen'
            className='delete-dialog'
            onEnter={() => window.addEventListener('keydown', downHandler)}
            title={generalStore.translate('deleteInteraction')}
            body={
                <div className="dialog-description">
                    {generalStore.translate('areYouSureYouWantToDelete')} {interactionName}?
                </div>
            }
            onConfirm={() => {
                modalStore.modalData.deleteMethod(interactionId).then();
                closeModal();
            }}
            confirmText={generalStore.translate('delete')}
        />
    );
});

export default DeleteInteractionModal;
